import { React } from '../Imports';
import { Card, Typography, CardContent, Container } from '../MaterialUIComponents';
import { IEventReviewServiceInjectedProps, EventReviewService } from '../state/EventReviewFreezer';
import { ConfigService, IConfigServiceInjectedProps } from '$State/ConfigFreezerService';
import videoProtectsStackedLogo = require('../assets/videoProtectsStacked.png');

interface IDriverEventAcceptedBaseProps {}

type IDriverEventAcceptedProps = IDriverEventAcceptedBaseProps & IEventReviewServiceInjectedProps & IConfigServiceInjectedProps;

interface IDriverEventAcceptedState {
    errorMsg: string;
    id: string;
    token: string;
    passwordHasError: boolean;
}

const styles = require('./DriverEventAccepted.scss') as {
    main: string;
    loginbutton: string;
    content: string;
    centeredText: string;
    buttonContainer: string;
    flex: string;
    bottomInfo: string;
    topInfo: string;
    logo: string;
};

class _DriverEventAccepted extends React.Component<IDriverEventAcceptedProps, IDriverEventAcceptedState> {
    state: IDriverEventAcceptedState = {
        errorMsg: '',
        id: '',
        token: '',
        passwordHasError: false,
    };

    componentDidMount() {
        this.props.eventReview.resetRedirectTo();
    }

    render() {
        return (
            <Container className={styles.main}>
                <Card className={styles.content}>
                    <img className={styles.logo} src={videoProtectsStackedLogo} />
                    <CardContent className={styles.centeredText}>
                        <Typography variant="h5" component="h2" align="center" className={styles.centeredText}>
                            Thank you for accepting the video event. Your acceptance has been communicated to the fleet manager.
                        </Typography>
                    </CardContent>
                </Card>
            </Container>
        );
    }
}

export const DriverEventAcceptedPage = EventReviewService.inject(ConfigService.inject(_DriverEventAccepted));
